import { WaitRankingLevel } from '../../dto/ServiceStatisticsDTO';
import { WaitLevel } from './alertThresholds';

/** Clase del `Tag` de cada nivel del semáforo de la espera media (siempre con texto: no depende del color). */
export const LEVEL_TAG_CLASS: Record<WaitLevel, string> = { ok: 'nv-tag-ok', warn: 'nv-tag-warn', err: 'nv-tag-err' };

/** Texto de cada nivel del semáforo de la espera media. */
export const LEVEL_LABEL_ID: Record<WaitLevel, string> = {
    ok: 'ServicesStatisticsWaitLevelOk',
    warn: 'ServicesStatisticsWaitLevelWarn',
    err: 'ServicesStatisticsWaitLevelErr',
};

/** El nivel que calcula el backend para «Dónde hay más espera», en el semáforo de la pantalla. */
export const RANKING_LEVEL: Record<WaitRankingLevel, WaitLevel> = { OK: 'ok', ATTENTION: 'warn', CRITICAL: 'err' };
